import React from "react"

class GrantHeaderComponent extends React.Component {

	render() {
		return (
			<div className={"custom-header-cell project" + (this.props.row.project.visible ? "" : " project-disabled")}>
				<span className="project-title">
					{ this.props.row.isSubGrant 
						? <div className="sub-project-spacer" />
						: null
					}
					<span>
						{this.props.row.title}
					</span>
				</span>
			</div>
		)
	}

}

export default GrantHeaderComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/grants/grant-header-component.js